<template>
  <div class="bg-white">
    <div class="order-info">
      <template v-if="current == 0">
        <double-details :orderDetails="orderDetails"></double-details>
      </template>
      <template v-if="current == 1">
        <Form
          ref="dataDetails"
          :model="dataDetails"
          :rules="ruleFrom"
          :label-width="120"
        >
          <double-info :otherObj="otherObj" :cnbNum="cnbNum">
          </double-info>
        </Form>
      </template>
      <template v-if="current == 2">
        <double-bill :billId="pageData"> </double-bill>
      </template>
    </div>

    <div class="footer-nav">
      <Button
        type="primary"
        @click="prev"
        :disabled="current == 0 ? true : false"
        icon="ios-arrow-back"
      >
        {{ $t("stepPrev") }}
      </Button>

      <div class="line-div">
        <Steps :current="current">
          <Step v-for="item in stepList" :key="item" :title="item"></Step>
        </Steps>
      </div>

      <Button
        type="primary"
        @click="next"
        :disabled="current == 2 ? true : false"
      >
        {{ $t("stepNext") }}
        <!-- {{ current != 2 ? $t("stepNext") : $t("order_submit") }} -->
        <Icon type="ios-arrow-forward" />
      </Button>
    </div>
  </div>
</template>
<script>
import {
  getDoubleDetails,
  getDoubleInfo,
  saveDoubleInfo,
  getContacts
} from "@/api/double/list";

import doubleInfo from "_my/double-info";
import doubleDetails from "_my/double-details";
import doubleBill from "_my/double-bill";

export default {
  components: {
    doubleDetails,
    doubleInfo,
    doubleBill
  },
  data() {
    return {
      orderDetails: {},
      stepList: [1, 2, 3],
      current: 0,
      dataDetails: {},
      ruleFrom: {
        dingcang_company: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change"
          }
        ],
        airline: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change"
          }
        ],
        cangku: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change"
          }
        ],
        start_gang: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change"
          }
        ],
        middle_gang: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change"
          }
        ],
        end_gang: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change"
          }
        ],
        maitou: [{}],
        weight: [{}],
        volume: [{}],
        dangzheng_user: [{}],
        shipping_terms: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change"
          }
        ],
        tuoyun_user: [{}],
        fee_terms: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change"
          }
        ],
        baoguan_type: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change"
          }
        ],
        kong_fee: [{}],
        fangdan_type: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change"
          }
        ]
      },
      unChange: false,
      otherObj: {},
      preForm: {}
    };
  },
  watch: {
    dataDetails: {
      handler: function(nowVal) {
        var $this = this;
        for (let i in $this.dataDetails) {
          if (nowVal[i] !== $this.preForm[i]) {
            $this.unChange = false;
            break;
          } else {
            $this.unChange = true;
          }
        }
      },
      deep: true
    }
  },
  computed: {
    pageData: function() {
      let data = this.$store.state.user.pageUrl;
      this.$store.state.user.pageUrl = {};
      return data;
    },
    isObj: function() {
      let bool = this.$store.state.user.isDouble;
      this.$store.state.user.isDouble = false;
      return bool;
    }
  },
  mounted() {
    if (this.isObj) {
      this.getList(this.pageData);
      this.getOtherList();
    }
  },
  methods: {
    getList(data) {
      getDoubleDetails(data)
        .then(res => {if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.orderDetails = res.data.payload;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getOtherList() {
      getContacts().then(res => {
        this.otherObj = res.data.payload;
      });
    },
    prev() {
      this.current -= 1;
    },
    next() {
      const cnbNum = this.orderDetails.airway_number;
      if (!cnbNum) {
        this.$Message["error"]({
          background: true,
          content: "Order cannot be empty",
          duration: 5
        });
        return;
      }
      if (this.current == 0) {
        getDoubleInfo(cnbNum).then(res => {
          console.log('xxx')
          if (res.data.payload != null) {
            this.dataDetails = res.data.payload;
            this.preForm = JSON.parse(JSON.stringify(res.data.payload));
          } else {
            this.dataDetails = {};
            this.preForm = {};
          }
        });
      }
      if (this.current == 1) {
        if (!this.unChange) {
          if (JSON.stringify(this.dataDetails) == "{}") {
            this.$Message["error"]({
              background: true,
              content: "Info cannot be empty",
              duration: 5
            });
            return;
          }
          saveDoubleInfo(cnbNum, this.dataDetails).then(res => {
            if (res.data.status) {
              this.$Message["success"]({
                background: true,
                content: res.data.msg,
                duration: 3
              });
            }
          });
        }
      }
      this.current += 1;
    }
  }
};
</script>
<style scoped lang="less">
.bg-white {
  background: #fff;
  height: 100%;
  padding: 10px;
  border-radius: 6px;
  overflow: auto;
}
.order-info {
  height: 730px;
  overflow: auto;
}
.footer-nav {
  display: flex;
  align-items: center;
  justify-content: center;
}
.line-div {
  width: 30%;
  margin: 0 20px;
}
</style>
